<script setup>
import { PhBook, PhGraduationCap, PhUsers, PhCertificate, PhHeart, PhStar } from '@phosphor-icons/vue'

const features = [
  { icon: PhBook,          title: 'Quranic Studies',        desc: 'Deep understanding of the Quran, Tafsir, and Tajweed.' },
  { icon: PhGraduationCap, title: 'Islamic Sciences',       desc: 'Comprehensive Hadith, Fiqh, and Arabic studies.' },
  { icon: PhHeart,         title: 'Character Development',  desc: 'Instilling noble akhlaq and moral excellence.' },
  { icon: PhStar,          title: 'Spiritual Environment',  desc: 'Daily prayers, Quranic recitation, and ethical guidance.' },
  { icon: PhUsers,         title: 'Diverse Community',      desc: 'Students from various backgrounds learning together.' },
  { icon: PhCertificate,   title: 'Accredited Programs',    desc: 'Certified programs recognized internationally.' },
]
</script>

<template>
  <section class="py-24 container mx-auto px-6">
    <div class="text-center mb-14">
      <h2 class="text-3xl font-bold text-primary mb-3">What We Offer</h2>
      <p class="text-gray-500 max-w-xl mx-auto">
        A comprehensive Islamic education built on authentic scholarship and noble values.
      </p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div
        v-for="(feature, i) in features"
        :key="i"
        class="group bg-white rounded-2xl p-8
               border border-primary/20
               shadow-sm hover:shadow-xl hover:-translate-y-2
               transition-all duration-300 flex flex-col items-center text-center"
      >
        <div class="w-16 h-16 rounded-xl bg-primary/10 group-hover:bg-primary/20
                    flex items-center justify-center transition-colors duration-300 mb-6">
          <component :is="feature.icon" class="text-primary w-8 h-8" />
        </div>
        <h3 class="text-lg font-bold text-primary mb-2">{{ feature.title }}</h3>
        <p class="text-gray-500 text-sm leading-relaxed">{{ feature.desc }}</p>
      </div>
    </div>
  </section>
</template>